import dayjs, { Dayjs } from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import localeData from 'dayjs/plugin/localeData'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(LocalizedFormat)
dayjs.extend(localeData)

export type AppDate = Dayjs // Use this type for all date operations

class DateService {
  getToday(): AppDate {
    return dayjs()
  }

  getClearDate(): AppDate {
    return this.getToday().hour(0).minute(0).second(0).millisecond(0)
  }

  getMonths(): string[] {
    return dayjs.months()
  }

  getDays(): string[] {
    return dayjs.weekdaysShort()
  }

  getDate(date: number | string | Date, format?: string): AppDate {
    return dayjs(date, format)
  }

  getDuration(ms: number) {
    return dayjs.duration(ms)
  }

  format(date: AppDate, query: string): string {
    return date.format(query)
  }
}

export const dateService = new DateService()
